import React, { FC, useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { defineMessages, useIntl } from "react-intl";
import { routes } from "@app/routing";
import { GisIntakeStep, STEP_ROUTE_SUFFIX } from "@app/service/intakeForm";
import { IntakeFormStepLayout } from "../components";
import { useIntakeForm } from "../context";

const messages = defineMessages({
  title: {
    id: "intakeStepDoctorAppointment.title",
    defaultMessage:
      "Do you already have an appointment scheduled with your doctor in the next 5 days?",
  },
  optionYes: {
    id: "intakeStepDoctorAppointment.optionYes",
    defaultMessage: "Yes",
  },
  optionNo: {
    id: "intakeStepDoctorAppointment.optionNo",
    defaultMessage: "No",
  },
  nextButton: {
    id: "intakeStepDoctorAppointment.nextButton",
    defaultMessage: "Next",
  },
});

const IntakeStepDoctorAppointment: FC = () => {
  const intl = useIntl();
  const navigate = useNavigate();
  const { orderUidPublic, testUid } = useParams<{
    orderUidPublic: string;
    testUid: string;
  }>();
  const {
    userInputFields,
    updateUserField,
    setCurrentStep,
    totalSteps,
    getNextStep,
    getPreviousStep,
  } = useIntakeForm();

  const currentStep = GisIntakeStep.DOCTOR_APPOINTMENT;
  const [selectedOption, setSelectedOption] = useState<boolean | null>(
    userInputFields.alreadyScheduledAppointmentWithDoctor
  );

  useEffect(() => {
    setCurrentStep(currentStep);
  }, [setCurrentStep]);

  const buildRoute = (step: GisIntakeStep | null) =>
    routes.scheduleAGeneticInformationSessionIntakePage(
      orderUidPublic || "",
      testUid || ""
    ) + (step ? STEP_ROUTE_SUFFIX[step] : "");

  const handleOptionChange = (value: boolean) => {
    setSelectedOption(value);
    updateUserField("alreadyScheduledAppointmentWithDoctor", value);
  };

  const handleContinue = () => {
    if (selectedOption === null) return;
    navigate(buildRoute(getNextStep(currentStep)));
  };

  const handleBack = () => {
    navigate(buildRoute(getPreviousStep(currentStep)));
  };

  return (
    <IntakeFormStepLayout
      currentStep={currentStep}
      totalSteps={totalSteps}
      title={intl.formatMessage(messages.title)}
      onContinue={handleContinue}
      onBack={handleBack}
      continueDisabled={selectedOption === null}
      continueLabel={intl.formatMessage(messages.nextButton)}
    >
      <div className="intake-form-step__radio-list">
        <label className="intake-form-step__radio-list__item">
          <input
            type="radio"
            name="doctor-appointment"
            className="intake-form-step__radio-list__input"
            checked={selectedOption === true}
            onChange={() => handleOptionChange(true)}
          />
          <span className="intake-form-step__radio-list__label">
            {intl.formatMessage(messages.optionYes)}
          </span>
        </label>
        <label className="intake-form-step__radio-list__item">
          <input
            type="radio"
            name="doctor-appointment"
            className="intake-form-step__radio-list__input"
            checked={selectedOption === false}
            onChange={() => handleOptionChange(false)}
          />
          <span className="intake-form-step__radio-list__label">
            {intl.formatMessage(messages.optionNo)}
          </span>
        </label>
      </div>
    </IntakeFormStepLayout>
  );
};

export default IntakeStepDoctorAppointment;
